import { ProfileData, ModuleGroupData } from './types'

export const createDefaultModules = (allChecked = true): ModuleGroupData[] => [
  {
    id: 'vendas',
    name: 'VENDAS',
    permissions: { ver: allChecked, criar: allChecked, editar: allChecked, deletar: allChecked },
    submenus: [
      { id: 'orcamentos', name: 'Orçamentos', permissions: { ver: allChecked, criar: allChecked, editar: allChecked, deletar: allChecked } },
      { id: 'rastreio', name: 'Rastreio', permissions: { ver: allChecked, criar: allChecked, editar: allChecked, deletar: allChecked } },
      { id: 'funil', name: 'Funil', permissions: { ver: allChecked, criar: allChecked, editar: allChecked, deletar: allChecked } },
    ],
  },
  {
    id: 'compras',
    name: 'COMPRAS',
    permissions: { ver: allChecked, criar: allChecked, editar: allChecked, deletar: allChecked },
    submenus: [
      { id: 'demanda', name: 'Demanda', permissions: { ver: allChecked, criar: allChecked, editar: allChecked, deletar: allChecked } },
      { id: 'pedidos_compra', name: 'Pedidos', permissions: { ver: allChecked, criar: allChecked, editar: allChecked, deletar: allChecked } },
    ],
  },
  {
    id: 'stock',
    name: 'ESTOQUE',
    permissions: { ver: allChecked, criar: allChecked, editar: allChecked, deletar: allChecked },
    submenus: [
      { id: 'materia_prima', name: 'Matéria prima', permissions: { ver: allChecked, criar: allChecked, editar: allChecked, deletar: allChecked } },
      { id: 'insumos', name: 'Insumos', permissions: { ver: allChecked, criar: allChecked, editar: allChecked, deletar: allChecked } },
      { id: 'produto_engenheirado', name: 'Produto engenheirado', permissions: { ver: allChecked, criar: allChecked, editar: allChecked, deletar: allChecked } },
    ],
  },
  {
    id: 'producao',
    name: 'PRODUÇÃO',
    permissions: { ver: allChecked, criar: allChecked, editar: allChecked, deletar: allChecked },
    submenus: [
      { id: 'ordens_producao', name: 'Ordens de produção', permissions: { ver: allChecked, criar: allChecked, editar: allChecked, deletar: allChecked } },
      { id: 'movimentacao', name: 'Movimentação', permissions: { ver: allChecked, criar: allChecked, editar: allChecked, deletar: allChecked } },
      { id: 'funil_producao', name: 'Funil', permissions: { ver: allChecked, criar: allChecked, editar: allChecked, deletar: allChecked } },
    ],
  },
  {
    id: 'financeiro',
    name: 'FINANCEIRO',
    permissions: { ver: allChecked, criar: allChecked, editar: allChecked, deletar: allChecked },
    submenus: [
      { id: 'lancamentos', name: 'Lançamentos', permissions: { ver: allChecked, criar: allChecked, editar: allChecked, deletar: allChecked } },
      { id: 'pagamentos', name: 'Pagamentos', permissions: { ver: allChecked, criar: allChecked, editar: allChecked, deletar: allChecked } },
      { id: 'itens', name: 'Itens', permissions: { ver: allChecked, criar: allChecked, editar: allChecked, deletar: allChecked } },
    ],
  },
  {
    id: 'conciliacao',
    name: 'CONCILIAÇÃO',
    permissions: { ver: allChecked, criar: allChecked, editar: allChecked, deletar: allChecked },
    submenus: [
      { id: 'a_receber', name: 'A receber', permissions: { ver: allChecked, criar: allChecked, editar: allChecked, deletar: allChecked } },
      { id: 'a_pagar', name: 'A pagar', permissions: { ver: allChecked, criar: allChecked, editar: allChecked, deletar: allChecked } },
      { id: 'entre_contas', name: 'Entre contas', permissions: { ver: allChecked, criar: allChecked, editar: allChecked, deletar: allChecked } },
    ],
  },
  {
    id: 'fiscal',
    name: 'FISCAL',
    permissions: { ver: allChecked, criar: allChecked, editar: allChecked, deletar: allChecked },
    submenus: [
      { id: 'nota_fiscal', name: 'Nota Fiscal', permissions: { ver: allChecked, criar: allChecked, editar: allChecked, deletar: allChecked } },
      { id: 'cenario_fiscal', name: 'Cenário Fiscal', permissions: { ver: allChecked, criar: allChecked, editar: allChecked, deletar: allChecked } },
    ],
  },
  {
    id: 'product-development',
    name: 'DESENVOLVIMENTO DE PRODUTO',
    permissions: { ver: allChecked, criar: allChecked, editar: allChecked, deletar: allChecked },
    submenus: [],
  },
  {
    id: 'qualidade',
    name: 'QUALIDADE',
    permissions: { ver: allChecked, criar: allChecked, editar: allChecked, deletar: allChecked },
    submenus: [
      { id: 'certificates', name: 'Certificados', permissions: { ver: allChecked, criar: allChecked, editar: allChecked, deletar: allChecked } },
      { id: 'parametros', name: 'Parâmetros', permissions: { ver: allChecked, criar: allChecked, editar: allChecked, deletar: allChecked } },
      { id: 'rnc', name: 'RNC', permissions: { ver: allChecked, criar: allChecked, editar: allChecked, deletar: allChecked } },
    ],
  },
  {
    id: 'analise-credito',
    name: 'ANÁLISE DE CRÉDITO',
    permissions: { ver: allChecked, criar: allChecked, editar: allChecked, deletar: allChecked },
    submenus: [],
  },
  {
    id: 'companies',
    name: 'EMPRESAS',
    permissions: { ver: allChecked, criar: allChecked, editar: allChecked, deletar: allChecked },
    submenus: [
      { id: 'todas_empresas', name: 'Todos', permissions: { ver: allChecked, criar: allChecked, editar: allChecked, deletar: allChecked } },
      { id: 'juridica', name: 'Jurídica', permissions: { ver: allChecked, criar: allChecked, editar: allChecked, deletar: allChecked } },
      { id: 'fisica', name: 'Física', permissions: { ver: allChecked, criar: allChecked, editar: allChecked, deletar: allChecked } },
      { id: 'propria', name: 'Própria', permissions: { ver: allChecked, criar: allChecked, editar: allChecked, deletar: allChecked } },
      { id: 'transportadora', name: 'Transportadora', permissions: { ver: allChecked, criar: allChecked, editar: allChecked, deletar: allChecked } },
    ],
  },
  {
    id: 'equipment',
    name: 'EQUIPAMENTOS',
    permissions: { ver: allChecked, criar: allChecked, editar: allChecked, deletar: allChecked },
    submenus: [
      { id: 'maquinas', name: 'Máquinas', permissions: { ver: allChecked, criar: allChecked, editar: allChecked, deletar: allChecked } },
      { id: 'veiculos', name: 'Veículos', permissions: { ver: allChecked, criar: allChecked, editar: allChecked, deletar: allChecked } },
    ],
  },
  {
    id: 'services',
    name: 'SERVIÇOS',
    permissions: { ver: allChecked, criar: allChecked, editar: allChecked, deletar: allChecked },
    submenus: [],
  },
  {
    id: 'profile',
    name: 'PESSOAS',
    permissions: { ver: allChecked, criar: allChecked, editar: allChecked, deletar: allChecked },
    submenus: [
      { id: 'user', name: 'Usuários', permissions: { ver: allChecked, criar: allChecked, editar: allChecked, deletar: allChecked } },
      { id: 'perfis_acesso', name: 'Perfis de acesso', permissions: { ver: allChecked, criar: allChecked, editar: allChecked, deletar: allChecked } },
      { id: 'regras', name: 'Regras', permissions: { ver: allChecked, criar: allChecked, editar: allChecked, deletar: allChecked } },
    ],
  },
  {
    id: 'relatorios',
    name: 'RELATÓRIOS',
    permissions: { ver: allChecked, criar: allChecked, editar: allChecked, deletar: allChecked },
    submenus: [
      { id: 'dashboards', name: 'Dashboards', permissions: { ver: allChecked, criar: allChecked, editar: allChecked, deletar: allChecked } },
      { id: 'exportacoes', name: 'Exportações', permissions: { ver: allChecked, criar: allChecked, editar: allChecked, deletar: allChecked } },
    ],
  },
  {
    id: 'roteirizacao',
    name: 'ROTEIRIZAÇÃO',
    permissions: { ver: allChecked, criar: allChecked, editar: allChecked, deletar: allChecked },
    submenus: [
      { id: 'fretes', name: 'Fretes', permissions: { ver: allChecked, criar: allChecked, editar: allChecked, deletar: allChecked } },
      { id: 'roteiros', name: 'Roteiros', permissions: { ver: allChecked, criar: allChecked, editar: allChecked, deletar: allChecked } },
    ],
  },
]

export const initialProfilesMock: ProfileData[] = [
  {
    id: 1,
    name: 'DEFAULT ADMIN',
    userCount: 1,
    modules: createDefaultModules(true),
  },
  {
    id: 2,
    name: 'GESTOR',
    userCount: 0,
    modules: createDefaultModules(true),
  },
  {
    id: 3,
    name: 'VENDEDOR',
    userCount: 3,
    modules: createDefaultModules(false).map((mod) => {
      if (mod.id === 'vendas' || mod.id === 'relatorios') {
        return {
          ...mod,
          submenus: mod.submenus.map((s) => ({
            ...s,
            permissions: { ver: true, criar: true, editar: true, deletar: false },
          })),
        }
      }
      return mod
    }),
  },
  {
    id: 4,
    name: 'FATURAMENTO',
    userCount: 1,
    modules: createDefaultModules(false).map((mod) => {
      if (mod.id === 'fiscal' || mod.id === 'financeiro') {
        return {
          ...mod,
          submenus: mod.submenus.map((s) => ({
            ...s,
            permissions: { ver: true, criar: true, editar: true, deletar: false },
          })),
        }
      }
      return mod
    }),
  },
  {
    id: 5,
    name: 'PRODUÇÃO',
    userCount: 2,
    modules: createDefaultModules(false).map((mod) => {
      if (mod.id === 'producao' || mod.id === 'estoque') {
        return {
          ...mod,
          submenus: mod.submenus.map((s) => ({
            ...s,
            permissions: { ver: true, criar: true, editar: true, deletar: true },
          })),
        }
      }
      return mod
    }),
  },
  {
    id: 6,
    name: 'FINANCEIRO',
    userCount: 1,
    modules: createDefaultModules(false).map((mod) => {
      if (mod.id === 'financeiro' || mod.id === 'conciliacao' || mod.id === 'fiscal') {
        return {
          ...mod,
          submenus: mod.submenus.map((s) => ({
            ...s,
            permissions: { ver: true, criar: true, editar: true, deletar: true },
          })),
        }
      }
      return mod
    }),
  },
  {
    id: 7,
    name: 'SOMENTE LEITURA',
    userCount: 3,
    modules: createDefaultModules(false).map((mod) => {
      if (mod.id === 'vendas') {
        return {
          ...mod,
          submenus: mod.submenus.map((s) => ({
            ...s,
            permissions: { ver: true, criar: false, editar: false, deletar: false },
          })),
        }
      }
      return mod
    }),
  },
]
